import React from "react";
import axios from "services/axios";
import _ from "lodash";
import { Card, message, Spin, Row, Button } from "antd";
import Lightbox from "react-image-lightbox";

import ApprovalInformation from "../../Component/Section/ApprovalInformation";
import CustomerInformation from "../../Component/Section/CustomerInformationTradeIn";
import SalesInformation from "../../Component/Section/SalesInformation";
import UsedCarInformation from "../../Component/Section/UsedCarInformation";
import NewCarInformation from "../../Component/Section/NewCarInformation";
import RuangNego from "../../Component/Section/RuangNego";
import Discount from "../../Component/Section/Discount";
import GrossProfitAat from "../../Component/Section/GrossProfitAat";
import RequestSectionFinish from "../../Component/Section/RequestSectionFinish";
import DealSection from "../../Component/Section/DealSection";
import MobbiInformation from "../../Component/Section/MobbiInformation";
import ModalDeal from "../../Component/Modal/ModalDeal";
import ModalNoDeal from "../../Component/Modal/ModalNoDeal";
import ModalConfirm from "../../Component/Modal/ModalConfirmOdoo";

class TradeInFinalDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      tradeIn: {},
      request: [],
      reasonNoDealList: [],
      calculation: [],
      commission: [],
      history: [],
      finalPrice: 0,
      visibleModalDeal: false,
      visibleModalNoDeal: false,
      visibleModalConfirm: false,
      visibleModalPhotoAppraisal: false,
      confirmLoading: false,
    };
    this.visibleModal = this.visibleModal.bind(this);
    this.formatRupiah = this.formatRupiah.bind(this);
    this.getValue = this.getValue.bind(this);
    this.changeFinalPrice = this.changeFinalPrice.bind(this);
    this.sendDealButton = this.sendDealButton.bind(this);
    this.sendNoDealButton = this.sendNoDealButton.bind(this);
    this.sendToOdooButton = this.sendToOdooButton.bind(this);
  }

  componentDidMount() {
    this.fetchTradeIn(this.props.match.params.id);
    this.fetchReasonNoDeal();
  }

  // ************************* Function Fetch Data *************************//
  fetchTradeIn(id) {
    this.setState({ isLoading: true });
    axios
      .get(`/admin-panel/trade-in/detail/${id}`)
      .then(result => {
        const sisaRuangNego = this.getValue(
          result.data.calculation,
          "name",
          "Sisa Ruang Nego"
        );

        this.setState({
          tradeIn: result.data.approvalTradeIn,
          request: result.data.approvalRequestStatus,
          calculation: result.data.calculation,
          commission: result.data.approvalTradeIn.ApprovalCommission
            ? result.data.approvalTradeIn.ApprovalCommission.commission
            : [],
          history: result.data.approvalHistory || [],
          isLoading: false,
          sisaRuangNego: sisaRuangNego,
        });
      })
      .catch(err => {
        this.setState({ isLoading: false });
        message.error("Gagal request data trade in");
      });
  }

  fetchReasonNoDeal() {
    axios
      .get(`/approval/reason-list`)
      .then(result => {
        this.setState({
          reasonNoDealList: result.data,
        });
      })
      .catch(err => {
        message.error("Gagal request reason no deal list");
      });
  }

  // ************************* Function Helper *************************//
  changeText(text) {
    switch (text) {
      case "MRP (Harga Max)":
        text = "Harga Final";
        break;
    }
    return text;
  }

  getValue(data, key, value) {
    let found;
    value = this.changeText(value);
    data = _.find(data, { [key]: value });
    if (data) {
      if (data.value || data.value == 0) {
        found = data.value;
      } else if (data.price || data.price == 0) {
        found = data.price;
      }
    }
    return found;
  }

  formatRupiah(number) {
    let data;
    if (number) {
      if (number !== "N/A") {
        data = `Rp. ${number
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, ".")},-`;
      } else {
        data = number;
      }
    } else {
      data = `Rp.0,-`;
    }
    return data;
  }

  // ************************* Function Open/Close Modal *************************//
  visibleModal(type, val) {
    switch (type) {
      case "Deal":
        this.setState({ visibleModalDeal: val });
        break;
      case "No Deal":
        this.setState({ visibleModalNoDeal: val });
        break;
      case "Confirm":
        this.setState({ visibleModalConfirm: val });
        break;
      case "Appraisal Photo":
        this.setState({ visibleModalPhotoAppraisal: val });
        break;
    }
  }

  // ************************* Function Change Final Price Deal *************************//
  changeFinalPrice(price) {
    this.setState({ finalPrice: price });
  }

  // ************************* Function Modal Send Button *************************//

  async sendDealButton(data) {
    try {
      data = {
        ...data,
        finalPrice: this.state.finalPrice,
      };
      const idApproval = this.props.match.params.id;
      await axios.put(`/approval/trade-in/finish/${idApproval}`, data);
      message.success("Success Finish Trade In");
      this.props.history.push(
        `/home/approval/trade-in-final-${this.props.location.query.status}`
      );
    } catch (e) {
      message.error("Gagal Deal Trade In");
    }
  }

  async sendNoDealButton(data) {
    try {
      const idApproval = this.props.match.params.id;
      await axios.put(`/approval/trade-in/finish/${idApproval}`, data);
      message.success("Success Finish Trade In");
      this.props.history.push(
        `/home/approval/trade-in-final-${this.props.location.query.status}`
      );
    } catch (e) {
      message.error("Gagal No Deal Trade In");
    }
  }

  async sendToOdooButton() {
    try {
      this.setState({ confirmLoading: true });
      const idApproval = this.props.match.params.id;
      await axios.put(`/admin-panel/trade-in/send-to-odoo/${idApproval}`, {});
      message.success("Success Send To Odoo");
      this.props.history.push(
        `/home/approval/trade-in-final-${this.props.location.query.status}`
      );
    } catch (e) {
      if (e.response) {
        if (e.response.data || e.response.message) {
          message.error(
            e.response.data.message || e.response.message || e.response.data
          );
        } else {
          message.error("Error Send to Odoo");
        }
      } else {
        message.error("Error Send to Odoo");
      }
      this.setState({ confirmLoading: false });
    }
  }

  async downloadPayload() {
    this.setState({ isLoading: true });
    const idApproval = this.props.match.params.id;

    await axios
      .get(`/admin-panel/approval/payload-odoo/${idApproval}`)
      .then(async v => {
        this.setState({ isLoading: false });
        if (v.data && v.data.payload) {
          let fileName = v.data.payload.booking_id || "Payload Odoo";
          let json = JSON.stringify(v.data.payload);
          let blob = new Blob([json], { type: "application/json" });
          let href = await URL.createObjectURL(blob);
          let link = document.createElement("a");
          link.href = href;
          link.download = fileName + ".json";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          message.success("Success Download Payload");
        } else {
          message.error("Error Download Payloads");
        }
      })
      .catch(e => {
        console.log(e, "error");
        if (e.response) {
          if (e.response.data || e.response.message) {
            message.error(
              e.response.data.message || e.response.message || e.response.data
            );
          } else {
            message.error("Error Download Payload");
          }
        } else {
          message.error("Error Download Payload");
        }
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  }

  isTrustCheck(approval) {
    let isTrust = true;

    let sourceOfRequest = _.get(approval, "Appraisal.Booking.sourceOfRequest");
    if (sourceOfRequest && sourceOfRequest === "MOBBI") {
      isTrust = false;
    }

    return isTrust;
  }

  render() {
    const { tradeIn, calculation, request, commission } = this.state;
    const { Appraisal, NewCar } = tradeIn;
    const photoAppraisal = Appraisal
      ? Appraisal.finalPrice.linkKacab
        ? Appraisal.finalPrice.linkKacab
        : Appraisal.finalPrice.link
      : null;
    let isTrust = this.isTrustCheck(tradeIn);

    return tradeIn.id ? (
      <Card
        title="TRADE IN FINAL"
        extra={
          tradeIn.approvalStatus === "Deal" && (
            <Button
              type="primary"
              ghost={true}
              target="blank"
              disabled={this.state.isLoading}
              onClick={() => this.downloadPayload()}>
              Download Payload
            </Button>
          )
        }>
        <Spin size="large" spinning={this.state.isLoading} tip="Loading...">
          <div id="ApprovalTradeInDetail">
            <ApprovalInformation approval={tradeIn} approvalType="Trade In" />
            <Row>
              <CustomerInformation data={Appraisal} />
              <SalesInformation data={Appraisal} />
            </Row>

            <Row>
              <UsedCarInformation
                appraisal={Appraisal}
                getValue={this.getValue}
                visibleModal={this.visibleModal}
              />
              <NewCarInformation
                edit={false}
                newCar={NewCar}
                formatRupiah={this.formatRupiah}
                visibleModal={this.visibleModal}
              />
            </Row>

            <Row>
              <MobbiInformation tradeIn={tradeIn} isTrust={isTrust} />
            </Row>

            <Row>
              <RuangNego
                calculation={calculation}
                request={request}
                formatRupiah={this.formatRupiah}
                getValue={this.getValue}
                isTrust={isTrust}
              />
              <Discount
                approvalType="Trade In"
                calculation={calculation}
                request={request}
                formatRupiah={this.formatRupiah}
                getValue={this.getValue}
              />
            </Row>

            <Row>
              <GrossProfitAat
                calculation={calculation}
                commission={commission}
                finalPrice={this.state.finalPrice}
                formatRupiah={this.formatRupiah}
                getValue={this.getValue}
              />
              <RequestSectionFinish
                approval={tradeIn}
                request={request}
                history={this.state.history}
                formatRupiah={this.formatRupiah}
                visibleModal={this.visibleModal}
              />
            </Row>
            <Row>
              <DealSection
                approvalType="Trade In"
                calculation={calculation}
                commission={commission}
                tradeInStatus={tradeIn.approvalStatus}
                sendToOdooStatus={tradeIn.sendToOdooStatus}
                changeFinalPrice={this.changeFinalPrice}
                visibleModal={this.visibleModal}
                isTrust={isTrust}
              />
            </Row>

            <ModalDeal
              approvalType="Trade In"
              checkButtonSend={this.state.checkButtonSend}
              visible={this.state.visibleModalDeal}
              sendButton={this.sendDealButton}
              visibleModal={this.visibleModal}
            />
            <ModalNoDeal
              reason={this.state.reasonNoDealList}
              visible={this.state.visibleModalNoDeal}
              sendButton={this.sendNoDealButton}
              visibleModal={this.visibleModal}
            />

            <ModalConfirm
              confirmLoading={this.state.confirmLoading}
              data={this.state.tradeIn}
              visible={this.state.visibleModalConfirm}
              sendButton={this.sendToOdooButton}
              visibleModal={this.visibleModal}
            />

            {this.state.visibleModalPhotoAppraisal && (
              <Lightbox
                mainSrc={photoAppraisal}
                onCloseRequest={() =>
                  this.visibleModal("Appraisal Photo", false)
                }
              />
            )}
          </div>
        </Spin>
      </Card>
    ) : null;
  }
}
export default TradeInFinalDetail;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/TradeIn/Final/TradeInDetail.js